import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { Observable } from 'rxjs';
import { StudentInstituteCheckListDTO } from '../../models/account/checkList/studentInstituteCheckListDTO';
import { StudentInstituteCheckListRequest } from '../../models/account/checkList/studentInstituteCheckListRequest';

@Injectable({
  providedIn: 'root'
})
export class StudentCheckListService {

  constructor(private genericService: GenericService) {

  }

  getStudentCheckList(request:StudentInstituteCheckListRequest, studentid?:string):Observable<StudentInstituteCheckListDTO>
  {
    return this.genericService.post(`user/checklist/${studentid}`,request)
  }

  updateStudentCheckList(stuInstituteCheckListRequest:StudentInstituteCheckListDTO,studentid?:string):Observable<StudentInstituteCheckListDTO>
  {
    return this.genericService.put(`user/updatechecklist/${studentid}`,stuInstituteCheckListRequest)
  }
}
